module.exports = __webpack_public_path__ + "static/media/CarfaxLogo.d23a2ee1.jpg";